import store from '@/store';
import { MSGS } from '@/utils/ppm/permissions';

export default [
    {
        routeName: 'msgs.index',
        items: [
            {
                title: 'add new message',
                routeName: 'msgs.create',
                params: {},
                allowed: () => store.getters['msgs/hasPermission'](MSGS.MESSAGES_MANAGEMENT),
            },
        ],
    },
    {
        routeName: 'msgs.details',
        items: [
            {
                title: 'duplicate',
                routeName: 'msgs.duplicate',
                params: {
                    messagingId: '{messagingId}',
                },
                allowed: () => store.getters['msgs/hasPermission'](MSGS.MESSAGES_MANAGEMENT),
            },
        ],
    },
];
